@use '../../../common/styles/variables' as *;

:host {
  display: block;
  @include default-css-variables;
  width: inherit;
}

.nylas-only-specific-time-availability {
  border: 1px solid var(--nylas-base-200);
  border-radius: var(--nylas-border-radius-2x);
  margin: 1rem;
  color: var(--nylas-base-900);
  background: var(--nylas-base-25);
}

.header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;

  .header-content {
    flex: 1;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      color: var(--nylas-base-900);
      text-align: left;
      display: flex;
      align-items: center;
      gap: 8px;

      .title-icon {
        display: inline-flex;
        align-items: center;

        tooltip-component {
          font-size: 0.875rem;
          font-weight: normal;
        }
      }
    }

    p {
      margin: 0.5rem 0 0 0;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 20px;
      color: var(--nylas-base-600);
      text-align: left;
    }
  }

  .toggle-wrapper {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
}

.info-box {
  margin: 0 1rem 1rem 1rem;
  padding: 1rem;
  background: var(--nylas-info-50, #e0f2fe);
  border: 1px solid var(--nylas-info-200, #93c5fd);
  border-radius: var(--nylas-border-radius-2x);
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;

  .info-box-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: var(--nylas-info, #0ea5e9);
    margin-top: 2px;
  }

  .info-box-content {
    flex: 1;

    h4 {
      margin: 0 0 0.25rem 0;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: var(--nylas-info-900, #0c4a6e);
    }

    p {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: var(--nylas-info-800, #075985);
    }
  }
}

toggle-switch {
  margin-right: 0;
  transform: scale(0.8);
  transform-origin: right center;
}
